//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('metaTableDatas', {
//        templateUrl: 'views/components/views/metaTableDatas/metaTableDatas.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['metaTableDatasService', function (metaTableDatasService) {
//            const vm = this;

//            vm.model = {
//                itemsListMetaTableDatas: []
//            };

//            async function loadMetaTableDatas() {
//                vm.model.itemsListMetaTableDatas = await metaTableDatasService.listMetaTableDatas();
//            }

//            vm.$onInit = async function () {
//                loadMetaTableDatas();
//            }
//        }]
//    });
//})();
